import styled from 'styled-components';
import Image from '@stencil/image';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  display: inline-block;
`;

export const ImageIcon = styled(Image)`
  width: 1.6rem;
  height: 1.6rem;
  cursor: pointer;
  margin-right: 0.4rem;
`;

export const TooltipCard = styled.div`
  position: absolute;
  top: 21px;
  left: 0;
  width: 42rem;
  background-color: white;
  color: black;
  padding: 10px;
  border: 1px solid #e4e4e4;
  border-radius: 8px;
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.2);
  z-index: ${props => props.theme.misc.zIndex.maximum || 10};
`;

export const modalTextDescription = styled.div`
  padding: 10px;
  border: 1px solid #e4e4e4;
  border-radius: 8px;
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.2);
`;
